var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "cp-popover",
      on: {
        click: function ($event) {
          $event.stopPropagation()
        },
      },
    },
    [
      _c(
        "div",
        {
          ref: "svBox",
          staticClass: "cp-sv",
          style: { backgroundColor: _vm.hueColor },
          on: { mousedown: _vm.startDragSV },
        },
        [
          _c("div", { staticClass: "cp-sv-white" }),
          _vm._v(" "),
          _c("div", { staticClass: "cp-sv-black" }),
          _vm._v(" "),
          _c("div", {
            staticClass: "cp-sv-handle",
            style: {
              left: _vm.sv.s * 100 + "%",
              top: (1 - _vm.sv.v) * 100 + "%",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "cp-controls" }, [
        _c(
          "button",
          {
            staticClass: "cp-eyedropper",
            attrs: { type: "button", title: "Pick color from screen" },
            on: { click: _vm.pickFromScreen },
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  width: "18",
                  height: "18",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              },
              [
                _c("path", { attrs: { d: "M2 22l1-4 9-9" } }),
                _vm._v(" "),
                _c("path", {
                  attrs: { d: "M17.5 3.5a2.121 2.121 0 0 1 3 3L18 9l-3-3z" },
                }),
                _vm._v(" "),
                _c("path", { attrs: { d: "M15 6l3 3" } }),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", {
          staticClass: "cp-swatch",
          style: { backgroundColor: _vm.hexValue },
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            ref: "hueSlider",
            staticClass: "cp-hue-slider",
            on: { mousedown: _vm.startDragHue },
          },
          [
            _c("div", {
              staticClass: "cp-hue-handle",
              style: { left: (_vm.hue / 360) * 100 + "%" },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cp-rgb-row" }, [
        _c("div", { staticClass: "cp-rgb-field" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.number",
                value: _vm.rgb.r,
                expression: "rgb.r",
                modifiers: { number: true },
              },
            ],
            attrs: { type: "number", min: "0", max: "255" },
            domProps: { value: _vm.rgb.r },
            on: {
              change: _vm.updateFromRGB,
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.rgb, "r", _vm._n($event.target.value))
              },
              blur: function ($event) {
                return _vm.$forceUpdate()
              },
            },
          }),
          _vm._v(" "),
          _c("label", [_vm._v("R")]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "cp-rgb-field" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.number",
                value: _vm.rgb.g,
                expression: "rgb.g",
                modifiers: { number: true },
              },
            ],
            attrs: { type: "number", min: "0", max: "255" },
            domProps: { value: _vm.rgb.g },
            on: {
              change: _vm.updateFromRGB,
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.rgb, "g", _vm._n($event.target.value))
              },
              blur: function ($event) {
                return _vm.$forceUpdate()
              },
            },
          }),
          _vm._v(" "),
          _c("label", [_vm._v("G")]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "cp-rgb-field" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.number",
                value: _vm.rgb.b,
                expression: "rgb.b",
                modifiers: { number: true },
              },
            ],
            attrs: { type: "number", min: "0", max: "255" },
            domProps: { value: _vm.rgb.b },
            on: {
              change: _vm.updateFromRGB,
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.rgb, "b", _vm._n($event.target.value))
              },
              blur: function ($event) {
                return _vm.$forceUpdate()
              },
            },
          }),
          _vm._v(" "),
          _c("label", [_vm._v("B")]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "cp-rgb-stepper" }, [
          _c(
            "button",
            {
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.nudge(1)
                },
              },
            },
            [_vm._v("\n        ▲\n      ")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.nudge(-1)
                },
              },
            },
            [_vm._v("\n        ▼\n      ")]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }